import { render, staticRenderFns } from "./PdvDeliverySender.vue?vue&type=template&id=45393c2b&scoped=true"
import script from "./PdvDeliverySender.vue?vue&type=script&lang=js"
export * from "./PdvDeliverySender.vue?vue&type=script&lang=js"
import style0 from "./PdvDeliverySender.vue?vue&type=style&index=0&id=45393c2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45393c2b",
  null
  
)

export default component.exports